/**
 * @author sgdh
 * @description 库存中心枚举
 */

import * as func from '@/func'

const enumToList = func.enumToList()


// 库存中心公共枚举-------------------------------------------------------------------------------------s
// 状态颜色规则
export enum ColorRuleEDEnum {
  'blue' = 1,
  'red' = 2,
}

// 是否(0-否，1-是)
export enum ZeroNoOneYesColorEnum {
  'red' = 0,
  'blue' = 1,
}
export enum EnableDisableCC {
  '启用' = 1,
  '禁用' = 2,
}
// 启用禁用(1-启用，2-禁用)
export enum EnableDisableOne {
  ENABLED = 1,
  DISABLED = 2,
}
export enum EnableDisableOneName {
  ENABLED = '启用',
  DISABLED = '禁用',
}

// 是否(1-是，2-否)
export enum OneYesTwoNoEnum {
  YES = 1,
  NO = 2,
}
export enum OneYesTwoNoEnumName {
  YES = '是',
  NO = '否',
}

// 是否(0-是，1-否)
export enum ZeroYesOneNoEnum {
  YES = 0,
  NO = 1,
}
export enum ZeroYesOneNoEnumName {
  YES = '是',
  NO = '否',
}

// 是否(0-否，1-是)
export enum ZeroNoOneYesEnum {
  NO = 0,
  YES = 1,
}
export enum ZeroNoOneYesEnumName {
  NO = '否',
  YES = '是',
}


// 库存中心公共枚举-------------------------------------------------------------------------------------e




// 云仓通知单------------
// 业务单据类型(1-采购单，2-采退单，3-销售单，4-转移单，5-盈亏单，6-报损单，7-组合拆套单，8-领用单，9-报废单，10-调剂单)
export enum BusinessType {
  PURCHASE_ORDER = 1,
  PURCHASE_RETURN_ORDER = 2,
  SALES_ORDER = 3,
  TRANSFER_ORDER = 4,
  PROFIT_AND_LOSS_ORDER = 5,
  DAMAGE_REPORT_ORDER = 6,
  COMBINATION_AND_UNBUNDLE_ORDER = 7,
  USE_ORDER = 8,
  SCRAP_REPORT_ORDER = 9,
  ADJUSTMENT_ORDER = 10,
}
export enum BusinessTypeName {
  PURCHASE_ORDER = '采购单',
  PURCHASE_RETURN_ORDER = '采退单',
  SALES_ORDER = '销售单',
  TRANSFER_ORDER = '转移单',
  PROFIT_AND_LOSS_ORDER = '盈亏单',
  DAMAGE_REPORT_ORDER = '报损单',
  COMBINATION_AND_UNBUNDLE_ORDER = '组合拆套单',
  USE_ORDER = '领用单',
  SCRAP_REPORT_ORDER = '报废单',
  ADJUSTMENT_ORDER = '调剂单',
}
// 发货类型枚举
export enum DeliveryType {
  SALES_SHIPMENT = 1,
  TRANSFER_SHIPMENT = 2,
  ADJUSTMENT_SHIPMENT = 3,
  PURCHASE_RETURN_SHIPMENT = 4,
}
export enum DeliveryTypeName {
  SALES_SHIPMENT = '销售发货',
  TRANSFER_SHIPMENT = '转移发货',
  ADJUSTMENT_SHIPMENT = '调剂发货',
  PURCHASE_RETURN_SHIPMENT = '采购退货发货',
}
// 发货类型枚举
export enum DeliveryStatus {
  SHIPPED = 1,
  NOT_SHIPPED = 2,
}
export enum DeliveryStatusName {
  SHIPPED = '已发货',
  NOT_SHIPPED = '未发货',
}

// 收货类型枚举
export enum TakeDeliveryType {
  SALES_SHIPMENT = 1,
  TRANSFER_SHIPMENT = 2,
  ADJUSTMENT_SHIPMENT = 3,
  PURCHASE_RETURN_SHIPMENT = 4,
}
export enum TakeDeliveryTypeName {
  SALES_SHIPMENT = '销售收货',
  TRANSFER_SHIPMENT = '转移收货',
  ADJUSTMENT_SHIPMENT = '调剂收货',
  PURCHASE_RETURN_SHIPMENT = '采购退货收货',
}
// 发货类型枚举
export enum TakeDeliveryStatus {
  SHIPPED = 1,
  NOT_SHIPPED = 2,
}
export enum TakeDeliveryStatusName {
  SHIPPED = '已收货',
  NOT_SHIPPED = '未收货',
}
// 云仓通知单据类型（in：收货， out：发货）
export enum CloudWarehouseTypeEnum {
  /**
   * 收货
   */
  IN = 'in',
  /**
   * 发货
   */
  OUT = 'out',
}
export enum CloudWarehouseTypeEnumName {
  IN = '收货',
  OUT = '发货',
}

// 实体仓--------------------------------
// 仓库状态(1-运行，2-停用)
export enum WarehouseStatus {
  RUNNING = 1, // 运行
  DISABLED, // 停用
}
export enum WarehouseStatusName {
  RUNNING = '启用', // 运行
  DISABLED = '停用', // 停用
}
// 是否默认仓库状态
export enum isDefault {
  DENY, // 否 deny
  CORRECT, // 是l correct
}

// 区域类型
export enum AttributeType {
  EDITION = 1,
  CLASSIFY,
}

// 业务仓----------------
// 发货类型枚举列表状态
export enum ManageStatus {
  ENABLED = 1,
  DISABLED = 2,
}
export enum ManageStatusName {
  ENABLED = '启用',
  DISABLED = '禁用',
}

// 弹窗----------
// 标签名称
export enum Department {
  E_COMMERCE = 1,
  LIBRARY,
  INNOVATION,
  TEXTBOOK,
  READING,
}
export enum DepartmentName {
  E_COMMERCE = '电商',
  LIBRARY = '馆配',
  INNOVATION = '创新',
  TEXTBOOK = '教材（教材、文教）',
  READING = '阅读事业部',
}

export enum WarehouseType {
  REGULAR = 1,
  GIFT,
  // DAMAGE,
}
export enum WarehouseTypeName {
  REGULAR = '普通仓',
  GIFT = '赠品仓',
  // DAMAGE = '报损仓',
}

export enum bookTaskType {
  RECEIVING_TASK = 1, // 收货任务单
  SHIPPING_TASK = 2, // 发货任务单
  COMBINATION_ORDER = 3,
  UNBUNDLING_ORDER = 4,
  DAMAGE_REPORT_ORDER = 5,
  SCRAP_REPORT_ORDER = 6,
  USAGE_ORDER = 7,
  CONSUMPTION_ORDER = 8,
  PROCESSING_ORDER = 9,
  RESERVATION_ALLOCATION_ORDER = 10,
  UP_RACK_ORDER = 11,
  DOWN_RACK_ORDER = 12,
  TRANSFER_ORDER = 13,
  ADJUSTMENT_ORDER = 14,
  RACK_ADJUSTMENT_ORDER = 15,
  INVENTORY_ORDER = 16,
  PROFIT_LOSS_ORDER = 17,
  SCRAP_REPORT_NOTIC_ORDER = 18,
  SALES_ORDER = 19,
  PURCHASE_ORDER = 20,
}

export enum bookTaskTypeName {
  RECEIVING_TASK = '收货任务单',
  SHIPPING_TASK = '发货任务单',
  COMBINATION_ORDER = '组套单',
  UNBUNDLING_ORDER = '拆套单',
  DAMAGE_REPORT_ORDER = '报损单',
  SCRAP_REPORT_ORDER = '报废单',
  USAGE_ORDER = '领用单',
  CONSUMPTION_ORDER = '消耗单',
  PROCESSING_ORDER = '加工单',
  RESERVATION_ALLOCATION_ORDER = '预留占用单',
  UP_RACK_ORDER = '上架单',
  DOWN_RACK_ORDER = '下架单',
  TRANSFER_ORDER = '转移单',
  ADJUSTMENT_ORDER = '调剂单',
  RACK_ADJUSTMENT_ORDER = '架位调整单',
  INVENTORY_ORDER = '盘点单',
  PROFIT_LOSS_ORDER = '盈亏单',
  SCRAP_REPORT_NOTIC_ORDER = '报废通知单',
  SALES_ORDER = '销售订单',
  PURCHASE_ORDER = '采购订单',
}
// 业务单据类型(1-采购单，2-采退单，3-销售单，4-转移单，5-盈亏单，6-报损单，7-组合拆套单，8-领用单，9-报废单，10-调剂单，18-占用单
export enum BookLogBizFormTypeEnum {
  PURCHASE_ORDER = 1,
  PURCHASE_RETURN_ORDER = 2,
  SALES_ORDER = 3,
  TRANSFER_ORDER = 4,
  PROFIT_AND_LOSS_ORDER = 5,
  DAMAGE_REPORT_ORDER = 6,
  COMBINATION_AND_UNBUNDLE_ORDER = 7,
  USE_ORDER = 8,
  SCRAP_REPORT_ORDER = 9,
  ADJUSTMENT_ORDER = 10,
  OCCUPY_ORDER = 18,
}
export enum BookLogBizFormTypeEnumName {
  PURCHASE_ORDER = '采购单',
  PURCHASE_RETURN_ORDER = '采退单',
  SALES_ORDER = '销售单',
  TRANSFER_ORDER = '转移单',
  PROFIT_AND_LOSS_ORDER = '盈亏单',
  DAMAGE_REPORT_ORDER = '报损单',
  COMBINATION_AND_UNBUNDLE_ORDER = '组合拆套单',
  USE_ORDER = '领用单',
  SCRAP_REPORT_ORDER = '报废单',
  ADJUSTMENT_ORDER = '调剂单',
  OCCUPY_ORDER = '占用单',
}

export enum bookProductType {
  BOOK = 1, // 图书
  NON_BOOK = 2, // 非图
  BUNDLE = 3, // 组合
  PROCESSING = 4, // 加工
  VOUCHER = 5, // 卡券
  SERVICE = 6, // 服务
  VIRTUAL = 7, // 虚拟
}

export enum bookProductTypeName {
  BOOK = '图书', // 图书
  NON_BOOK = '非图', // 非图
  BUNDLE = '组合', // 组合
  PROCESSING = '加工', // 加工
  VOUCHER = '卡券', // 卡券
  SERVICE = '服务', // 服务
  VIRTUAL = '虚拟', // 虚拟
}

// 是否含组合商品(1:是,2:否)
export enum bookYesNo {
  YES = 1,
  NO = 2,
}

export enum bookYesNoName {
  YES = '是',
  NO = '否',
}

// 调拨-转移------------
// 转移类型
export enum XefrType {
  TRANSFER = 1,
  ADJUSTMENT = 2,
}
export enum XefrTypeName {
  TRANSFER = '转移',
  ADJUSTMENT = '调剂单',
}
//
export enum transferFormType {
  OUTBOUND = 1,
  WAREHOUSING = 2,
  TRANSFER = 2,
}
export enum transferFormTypeName {
  OUTBOUND = '转移',
  WAREHOUSING = '调剂单',
  TRANSFER = '调剂单',
}
// 发货状态
export enum TransferDeliveryStatus {
  NOT_AUDIT = 0,
  NOT_SHIPPED = 1,
  SHIPPED = 2,
  RECEIVED = 3,
}
export enum TransferDeliveryStatusName {
  NOT_AUDIT = '待提交',
  NOT_SHIPPED = '待发货',
  SHIPPED = '已发货',
  RECEIVED = '已收货',
}

export enum TransferDeliveryType {
  // TO_SHIP = 1,
  EXPRESS = 2,
  SELF_PICKUP = 3,
}
export enum TransferDeliveryTypeName {
  // TO_SHIP = '无需发货',
  EXPRESS = '物流',
  SELF_PICKUP = '自提',
}

// 库存操作
export enum MaterialDeliveryType {
  SELF_PICKUP = 1,
  EXPRESS = 2,
}
export enum MaterialDeliveryTypeName {
  SELF_PICKUP = '自提',
  EXPRESS = '快递',
}

// 收货管理-------------------------------
// 收货类型(1-采购收货，2-销退收货，3-转移收货，4-调剂收货，5-赠品收货，6-虚拟商品收货)
export enum WmReceiptType {
  PROCUREMENT = 1,
  SALES_RETURN = 2,
  TRANSFER = 3,
  ADJUSTMENT = 4,
  GIFT = 5,
  VIRTUAL_GOODS = 6,
}
export enum WmReceiptTypeName {
  PROCUREMENT = '采购收货',
  SALES_RETURN = '销退收货',
  TRANSFER = '转移收货',
  ADJUSTMENT = '调剂收货',
  GIFT = '赠品收货',
  VIRTUAL_GOODS = '虚拟商品收货',
}

/**
 * 功能：单据状态(（1.草稿或新建-b/初始化失败-c)、2.待审核、3.已驳回（审核失败）、4.已审核、5.已取消、6.已关闭)
 */
export enum MapState {
  DRAFT = 1,
  PENDING_APPROVAL = 2,
  EFFECTIVE = 3,
  REJECTED = 4,
  CANCELLED = 5,
  CLOSED = 6,
}
export enum MapStateName {
  DRAFT = '草稿',
  PENDING_APPROVAL = '待审核',
  EFFECTIVE = '已驳回',
  REJECTED = '已审核',
  CANCELLED = '已取消',
  CLOSED = '已关闭',
}
/**
 * 功能：库存作业状态(1-待收货 2 -已到货、3-已收货)
 */
export enum MapStockStatus {
  WAITING = 1,
  ARRIVED_CONFIRMATION = 2,
  RECEIVED = 3,
}
export enum MapStockStatusName {
  WAITING = '待收货',
  ARRIVED_CONFIRMATION = '已收货',
  RECEIVED = '拒收',
}
/**
 * 业务属性1（1-教材，2-电商，3-阅读 ，4-馆配 ，5-创新
 */
export enum MapBizAttrType {
  TEACH = 1,
  COMMERCE = 2,
  READ = 3,
  MATCH = 4,
  INNOVATION = 5,
}
export enum MapBizAttrTypeName {
  TEACH = '教材',
  COMMERCE = '电商',
  READ = '阅读',
  MATCH = '馆配',
  INNOVATION = '创新',
}
/**
 * 业务模式（1-批发，2-团购，3-零售）
 */
export enum MapBizMode {
  WHOLESALE = 1,
  BUY = 2,
  RETAIL = 3,
}
export enum MapBizModeName {
  WHOLESALE = '批发',
  BUY = '团购',
  RETAIL = '零售',
}
/**
 * 商品业务类型（分为1.常规、2.卡券（充值卡&提货券）；）
 */
export enum MapProductBizType {
  ROUTINE = 1,
  COUPONS = 2,
}
export enum MapProductBizTypeName {
  ROUTINE = '常规',
  COUPONS = '卡券',
}
/**
 * 结算方式（1.赊账、2.现结 ，3.内部结算 内部客户只能选择内部结算）
 */
export enum MapSettlementType {
  CREDIT = 1,
  READYTOSETTLE = 2,
  INTERNALSETTLEMENT = 3,
}
export enum MapSettlementTypeName {
  CREDIT = '赊账',
  READYTOSETTLE = '现结',
  INTERNALSETTLEMENT = '内部结算',
}
// 云仓 收货通知单 收货状态1-待收货，2-已到货确认，3-已收货
export enum YCWmReceiptStatus {
  待收货 = 1,
  已收货 = 3,
}

export const YCWmReceiptStatusList = Object.freeze(enumToList({ YCWmReceiptStatus }))
// 收货状态1-待收货，2-已到货确认，3-已收货
export enum WmReceiptStatus {
  WAITING = 1,
  ARRIVED_CONFIRMATION = 2,
  RECEIVED = 3,
}
export enum WmReceiptStatusName {
  WAITING = '待收货',
  ARRIVED_CONFIRMATION = '已到货确认',
  RECEIVED = '已收货',
}
// 包件验收情况1-完好，2-湿包污染，3-破损散包，4-少件
export enum PackageAcceptanceStatus {
  GOOD_ANGEL = 1,
  WET_BAG_CONTAMINATION = 2,
  BROKEN_SCATTERED_BAG = 3,
  MISSING_ITEMS = 4,
}
export enum PackageAcceptanceStatusName {
  GOOD_ANGEL = '完好',
  WET_BAG_CONTAMINATION = '湿包污染',
  BROKEN_SCATTERED_BAG = '破损散包',
  MISSING_ITEMS = '少件',
}
// 拒收类型1-污损，2-少附件，3-不成套，4-品种错，5-量出错，6-串包或少包
export enum RejectType {
  DIRTY = 1,
  MISSING_ATTACHMENTS = 2,
  INCOMPLETE_SET = 3,
  WRONG_VARIETY = 4,
  QUANTITY_INCORRECT = 5,
  MIXED_UP_OR_MISSING_PACKAGES = 6,
}
export enum RejectTypeName {
  DIRTY = '污损',
  MISSING_ATTACHMENTS = '少附件',
  INCOMPLETE_SET = '不成套',
  WRONG_VARIETY = '品种错',
  QUANTITY_INCORRECT = '量出错',
  MIXED_UP_OR_MISSING_PACKAGES = '串包或少包',
}

// 报废单-------------------------------------
// 报废类型(1-手工创建 2-报废通知单)
export enum ScrapTypeEn {
  MANUAL = 1,
  NOTICE = 2,
}
export enum ScrapTypeEnName {
  MANUAL = '手工创建',
  NOTICE = '报废通知单',
}

// 报废单审批状态: （1-待提交 2-审核中 3-审核不通过 4-审核通过)
export enum ScrapDocumentAuditEn {
  PENDING_SUBMIT = 1,
  UNDER_REVIEW = 2,
  REVIEW_NOT_PASS = 3,
  REVIEW_PASS = 4,
}
export enum ScrapDocumentAuditEnName {
  PENDING_SUBMIT = '待提交',
  UNDER_REVIEW = '审核中',
  REVIEW_NOT_PASS = '审核不通过',
  REVIEW_PASS = '审核通过',
}

// 报废单单据状态(1-未完结 2-已作废 3-已完结)
export enum ScrapDocumentStatusEn {
  UNFINISHED = 1,
  INVALID = 2,
  COMPLETED = 3,
}
export enum ScrapDocumentStatusEnName {
  UNFINISHED = '未完结',
  INVALID = '已作废',
  COMPLETED = '已完结',
}

// 报废通知单单据状态(1-待提交 2-待下发 3-已下发 4-已过期 5-已结束 6-已完结)
export enum ScrapNoticeStatusEn {
  TO_BE_SUBMITTED = 1,
  TO_BE_ISSUED = 2,
  ISSUED = 3,
  EXPIRED = 4,
  ENDED = 5,
  COMPLETED = 6,
}
// 报废通知单单据状态
export enum ScrapNoticeStatusEnName {
  TO_BE_SUBMITTED = '待提交',
  TO_BE_ISSUED = '待下发',
  ISSUED = '已下发',
  EXPIRED = '已过期',
  ENDED = '已结束',
  COMPLETED = '已完结',
}

// 报废通知单回执状态'1-待回执 2-部分回执 3-全部回执',
export enum ScrapNoticeExecuteEn {
  PENDING_RE = 1,
  PARTIAL_RE = 2,
  ALL_RE = 3,
}
// 报废通知单回执状态
export enum ScrapNoticeExecuteEnName {
  PENDING_RE = '待回执',
  PARTIAL_RE = '部分回执',
  ALL_RE = '全部回执',
}

//组合拆套-------------------------------
export enum CsFormTypeEn {
  COM = 1,
  DIS = 2,
}

export enum CsFormTypeEnName {
  COM = '组合单',
  DIS = '拆套单',
}

//预留占用-------------------------------
// 使用状态（1-未使用、2-部分使用、3-已完全使用）
export enum UseStatusEn {
  NOT_USED = 1,
  PARTIALLY_USED = 2,
  COMPLETELY_USED = 3,
}
export enum UseStatusEnName {
  NOT_USED = '未使用',
  PARTIALLY_USED = '部分使用',
  COMPLETELY_USED = '已完全使用',
}

// 领用----------------------------------------------------
// 发货状态下拉
export enum ExamineStatusOptionsEn {
  TO_BE_SUBMITTED = 1,
  IN_REVIEW = 2,
  APPROVED = 3,
  REVIEW_FAILED = 4,
}
// 1、待提交，2-审核中，3-审核通过，4-审核未通过)
export enum ExamineStatusOptionsEnName {
  TO_BE_SUBMITTED = '待提交',
  IN_REVIEW = '审核中',
  APPROVED = '审核通过',
  REVIEW_FAILED = '审核未通过',
}
// 执行状态下拉
export enum ExecuteStatusOptionsEn {
  PENDING = 1,
  COMPLETED = 2,
}
export enum ExecuteStatusOptionsEnName {
  PENDING = '待执行',
  COMPLETED = '执行完成',
}

// 批次查询-------------------------
// 收发货类型(1-收货任务单，2-发货任务单)
export enum InOutTypeEnum {
  RECEIVING_TASK = 1,
  SHIPPING_TASK = 2,
}
export enum InOutTypeEnumName {
  RECEIVING_TASK = '收货任务单',
  SHIPPING_TASK = '发货任务单',
}

//公用------------------------
//业务组类型(0采购，1销售)
export enum BusinessGroupTypeEn {
  PROCUREMENT = 0,
  SALES = 1,
}
export enum BusinessGroupTypeEnName {
  PROCUREMENT = '采购组',
  SALES = '销售组',
}

// 单审批状态: （1-待提交 2-审核中 3-审核通过 4-审核不通过)
export enum DocumentStatus {
  PENDING_SUBMIT = 1,
  UNDER_REVIEW = 2,
  REVIEW_PASS = 3,
  REVIEW_NOT_PASS = 4,
}
export enum DocumentStatusName {
  PENDING_SUBMIT = '待提交',
  UNDER_REVIEW = '审核中',
  REVIEW_PASS = '审核通过',
  REVIEW_NOT_PASS = '审核不通过',
}

// 仓库属性(1-自管仓库;2-云仓)
export enum WhTypeEnum {
  /**
   * 自管仓库
   */
  SELF_MANAGED = 1,
  /**
   * 云仓
   */
  CLOUD = 2,
}
export enum WhTypeEnumName {
  SELF_MANAGED = '自管仓库',
  CLOUD = '云仓',
}
